import React from 'react';
import PropTypes from 'prop-types';

import { Mobile } from 'app/components/Responsive';
import Snackbar from 'app/components/Snackbar';
import './push-notifications-popup.scss';

// /**
//  * @deprecated FRNT-3633
//  */
export default function PushNotificationsPopup(props) {
    const { onClickAccept, onClickClose } = props;

    return (
        <Mobile>
            <div styleName="push-notifications-popup__container">
                <Snackbar
                    onClickClose={null}
                >
                    <div styleName="push-push-notifications-popup__content">
                        <p styleName="push-notifications-popup__text main">
                            Хотите включить уведомления?
                        </p>
                        <p styleName="push-notifications-popup__text">
                            Там ваши персональные скидки и акции
                        </p>
                        <div styleName="push-notifications-popup__buttons">
                            <button
                                type="button"
                                styleName="app-banner__link"
                                onClick={onClickClose}
                            >
                                Не хочу
                            </button>
                            <button
                                type="button"
                                styleName="app-banner__link"
                                onClick={onClickAccept}
                            >
                                Хочу!
                            </button>
                        </div>
                    </div>
                </Snackbar>
            </div>
        </Mobile>
    );
}

PushNotificationsPopup.propTypes = {
    onClickAccept: PropTypes.func.isRequired,
    onClickClose: PropTypes.func.isRequired,
};
